/**
 * TeleTime POS - Switch User / Sign Out
 *
 * Switch User is the everyday action: back to the PIN pad, the terminal stays registered.
 * Sign Out is the device logout — it forgets the terminal, and a manager must initialize it
 * again — so it asks first and says so. Register 2 dropped to Initialize Terminal twice on
 * 2026-09-21 because "Sign Out" did that with no warning (P1).
 */

import { useState } from 'react';
import { LogIn, Users } from 'lucide-react';
import { ConfirmDialog } from './ConfirmDialog';

export const DEREGISTER_MESSAGE =
  'This will de-register this terminal; a manager must re-initialize it.';

/**
 * @param {object} props
 * @param {function} props.onSwitchUser - back to the PIN pad, terminal kept
 * @param {function} props.onSignOut - runs only after the cashier confirms the de-registration
 * @param {function} [props.onBeforeAction] - e.g. close the menu
 * @param {'menu'|'bar'} [props.variant]
 */
export function SessionActions({ onSwitchUser, onSignOut, onBeforeAction, variant = 'menu' }) {
  const [confirming, setConfirming] = useState(false);

  const bar = variant === 'bar';
  return (
    <>
      <button
        type="button"
        data-testid="switch-user"
        onClick={() => { onBeforeAction?.(); onSwitchUser(); }}
        className={bar
          ? 'flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors'
          : 'w-full flex items-center gap-3 px-4 py-3 text-left font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors'}
      >
        <Users className="w-5 h-5" />
        <span>Switch User</span>
      </button>

      <button
        type="button"
        data-testid="sign-out"
        onClick={() => setConfirming(true)}
        className={bar
          ? 'flex items-center gap-2 px-4 py-2 bg-slate-700 hover:bg-slate-600 text-red-300 rounded-lg transition-colors'
          : 'w-full flex items-center gap-3 px-4 py-3 text-left text-red-600 hover:bg-red-50 transition-colors'}
      >
        <LogIn className="w-5 h-5" />
        <span className="flex flex-col">
          <span>Sign Out</span>
          <span className="text-xs text-gray-400">De-registers this terminal</span>
        </span>
      </button>

      <ConfirmDialog
        isOpen={confirming}
        title="Sign out and de-register this terminal?"
        message={DEREGISTER_MESSAGE}
        confirmLabel="De-register terminal"
        onCancel={() => setConfirming(false)}
        onConfirm={() => { setConfirming(false); onBeforeAction?.(); onSignOut(); }}
      />
    </>
  );
}

export default SessionActions;
